import { render, staticRenderFns } from "./PurchaseOrderInvoiceLoader.vue?vue&type=template&id=8cb63ba8&scoped=true"
import script from "./PurchaseOrderInvoiceLoader.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderInvoiceLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb63ba8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/PurchaseOrderInvoiceLoader.vue
// module id = 2356
// module chunks = 31